module.exports = __webpack_public_path__ + "static/media/pushkala_content.5ea61acb.jpg";